import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignsPlatformLabelPopoverProperty({
  label,
  value
}) {
  return /*#__PURE__*/_jsxs(DescriptionList, {
    children: [/*#__PURE__*/_jsx("dt", {
      children: label
    }), /*#__PURE__*/_jsx("dd", {
      children: value
    })]
  });
}